import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
const AdminTable = (props) => {
    const {rowsPerPage,currentPage,totalRecords,onHandleTableChange,...otherProps}=props
    const handleTableChange = (type, { page, sizePerPage }) => {
        console.log("page, sizePerPage",page, sizePerPage)
        onHandleTableChange(page, sizePerPage)
    }
    
    return <div className="adminTable">
    <BootstrapTable
    {...otherProps}
    bootstrap4={true}
    wrapperClasses="table-responsive"
    remote
    rowStyle={{
        backgroundColor: "#fff"
    }}
    pagination={totalRecords>rowsPerPage?paginationFactory({
        sizePerPage:rowsPerPage,
        showTotal: true,
        totalSize: totalRecords,
        page:currentPage,
        sizePerPageList: [5, 10, 25, 50, 100, 150, 200]
        
    }):undefined}
    
    onTableChange={handleTableChange}
    noDataIndication={<div style={{
        textAlign: 'center',
        fontStyle: 'italic',
        fontSize: '3vh',
        color: 'gray',
        marginTop: '2vh',
        width: '100%'
    }}>
        No {props.dataIndicationName?props.dataIndicationName:""} Data Available
    </div>}

/></div>
}

export default AdminTable